import { useCallback, useEffect, useState } from "react";
import { chatApi } from "../api";

export type Conversation = {
  id: string;
  title: string;
  teammate_id: string | null;
  created_at: string;
  updated_at: string;
};

export function renameConversation(id: string, title: string) {
  return chatApi.renameConversation(id, title).then(() => {
    window.dispatchEvent(new CustomEvent("conversation-updated"));
  });
}

export function useConversations() {
  const [conversations, setConversations] = useState<Conversation[]>([]);

  const reload = useCallback(() => {
    chatApi
      .listConversations()
      .then((res) =>
        setConversations(Array.isArray(res.data) ? res.data : []),
      )
      .catch(() => {});
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    window.addEventListener("conversation-updated", reload);
    window.addEventListener("focus", reload);
    return () => {
      window.removeEventListener("conversation-updated", reload);
      window.removeEventListener("focus", reload);
    };
  }, [reload]);

  const removeConversation = useCallback(
    (id: string) =>
      chatApi.deleteConversation(id).then(() => {
        setConversations((prev) => prev.filter((c) => c.id !== id));
      }),
    [],
  );

  return { conversations, reload, removeConversation };
}
